export type AllergensSource = {
	allergens?: string[] | null;
	loc_allergens?: Record<string, string[] | null | undefined> | null;
};

export type AllergensModifierInput = AllergensSource & {
	amount?: number | null;
};

export type AllergensGroupInput = {
	modifiers?: AllergensModifierInput[] | null;
};

/** В `loc_allergens` приходят только заполненные языки — для остальных показываем `allergens`. */
export const getLocaleAllergens = (item: AllergensSource | null | undefined, language: string): string[] => {
	const localized = item?.loc_allergens?.[language];
	if (localized?.length) return localized;
	return item?.allergens ?? [];
};

/** Аллергены блюда и выбранных модификаторов (amount > 0) без повторов, в порядке появления. */
export const collectAllergens = (
	product: AllergensSource | null | undefined,
	groupsSelected: AllergensGroupInput[] | null | undefined,
	language: string,
): string[] => {
	const unique = new Map<string, string>();

	const append = (item: AllergensSource) => {
		for (const raw of getLocaleAllergens(item, language)) {
			const name = typeof raw === "string" ? raw.trim() : "";
			const key = name.toLocaleLowerCase();
			if (name && !unique.has(key)) unique.set(key, name);
		}
	};

	if (product) append(product);

	for (const group of groupsSelected ?? []) {
		for (const modifier of group.modifiers ?? []) {
			if (Number(modifier.amount ?? 0) > 0) append(modifier);
		}
	}

	return [...unique.values()];
};
